// Mock data for NO! APOLOGY Podcast

export const podcastInfo = {
  title: "NO! APOLOGY",
  subtitle: "NAKETA JACKSON'S PODCAST",
  description: "A dynamic podcast exploring reggae, Caribbean culture, entertainment, and the diaspora experience with host Naketa Jackson - versatile entertainer, singer, songwriter, and cultural ambassador.",
  host: {
    name: "Naketa Jackson",
    title: "Host & Creator",
    bio: "Naketa Jackson is widely recognized as a talented and dynamic entertainer whose career spans music, modeling, acting, entrepreneurship, and philanthropy. Known for her vibrant personality and strong stage presence, Jackson has built a reputation as one of reggae's versatile female performers, earning admiration from fans and colleagues alike for both her creativity and charitable spirit.",
    fullBio: [
      "A singer, songwriter, dancer, actress, poet, and entrepreneur, Jackson has steadily carved out her space in the entertainment industry. Her work reflects a deep passion for the arts and a commitment to developing her craft.",
      "Born in Kingston, Jamaica, she grew up surrounded by music and artistic expression. She started singing at age two and joined her church choir at eight. Her grandfather, Lascelles Perkins, was a respected veteran singer, and both of her parents were musically inclined.",
      "After migrating to New York City at age 16, Jackson balanced academic pursuits with her growing interest in entertainment, eventually choosing to focus on her artistic ambitions and performing professionally.",
      "Over the years, Jackson has performed across the United States, Canada, Italy, parts of Africa, and the Caribbean. She has recorded more than thirty songs, including fan favorites such as 'Summertime', 'Push It On Me', 'Call Me', and 'Independence'.",
      "Jackson spent three years in Ghana, where she performed extensively, conducted media interviews, and participated in charitable initiatives while promoting reggae music and Caribbean culture throughout West Africa.",
      "Beyond music, Jackson co-owned the entertainment and talent development company Fiery Ize Vision, supporting emerging artists and creative talent. She remains involved in charitable work and community outreach initiatives, particularly those supporting youth development, arts education, and cultural empowerment."
    ],
    image: "https://customer-assets.emergentagent.com/job_reggae-naketa-show/artifacts/zk3yzjdr_1000138430.jpg",
    social: {
      instagram: "#",
      twitter: "#",
      facebook: "#",
      youtube: "#"
    }
  },
  branding: {
    logoText: "https://customer-assets.emergentagent.com/job_c3031336-6347-47fa-b8fc-2ca0bb5ade68/artifacts/eypkhh77_logotext.png",
    logoMic: "https://customer-assets.emergentagent.com/job_c3031336-6347-47fa-b8fc-2ca0bb5ade68/artifacts/3smwfqus_logomic.png",
    hostImage: "https://customer-assets.emergentagent.com/job_c3031336-6347-47fa-b8fc-2ca0bb5ade68/artifacts/26yhn2np_Screen%20Shot%202026-03-09%20at%204.10.26%20AM.png"
  }
};

export const episodes = [
  {
    id: 1,
    title: "The Journey from Kingston to the World Stage",
    description: "Naketa shares her incredible journey from singing in church choirs in Kingston, Jamaica to performing on international stages across multiple continents.",
    duration: "45:23",
    date: "2026-03-01",
    season: 1,
    episode: 12,
    audioUrl: "https://files.freemusicarchive.org/storage-freemusicarchive-org/music/no_curator/Tours/Enthusiast/Tours_-_01_-_Enthusiast.mp3",
    topics: ["Biography", "Music Journey", "Jamaica"],
    featured: true
  },
  {
    id: 2,
    title: "Reggae's Global Impact and Caribbean Culture",
    description: "Exploring how reggae music has influenced global culture and the importance of preserving Caribbean heritage in the diaspora.",
    duration: "38:15",
    date: "2026-02-15",
    season: 1,
    episode: 11,
    audioUrl: "https://files.freemusicarchive.org/storage-freemusicarchive-org/music/no_curator/Tours/Enthusiast/Tours_-_01_-_Enthusiast.mp3",
    topics: ["Reggae", "Culture", "Global Impact"],
    featured: true
  },
  {
    id: 3,
    title: "Women in Reggae: Breaking Barriers",
    description: "A candid conversation about the challenges and triumphs of female artists in the reggae industry and how to empower the next generation.",
    duration: "42:10",
    date: "2026-02-01",
    season: 1,
    episode: 10,
    audioUrl: "https://files.freemusicarchive.org/storage-freemusicarchive-org/music/no_curator/Tours/Enthusiast/Tours_-_01_-_Enthusiast.mp3",
    topics: ["Women in Music", "Empowerment", "Industry"],
    featured: true
  },
  {
    id: 4,
    title: "Three Years in Ghana: African Connections",
    description: "Reflecting on three transformative years in Ghana, promoting reggae music and building bridges between Caribbean and African cultures.",
    duration: "51:30",
    date: "2026-01-15",
    season: 1,
    episode: 9,
    audioUrl: "https://files.freemusicarchive.org/storage-freemusicarchive-org/music/no_curator/Tours/Enthusiast/Tours_-_01_-_Enthusiast.mp3",
    topics: ["Ghana", "Africa", "Cultural Exchange"],
    featured: false
  },
  {
    id: 5,
    title: "The Art of Performance: From Stage to Screen",
    description: "Discussing the versatility required to excel in multiple entertainment fields including music, acting, and modeling.",
    duration: "36:45",
    date: "2026-01-01",
    season: 1,
    episode: 8,
    audioUrl: "https://files.freemusicarchive.org/storage-freemusicarchive-org/music/no_curator/Tours/Enthusiast/Tours_-_01_-_Enthusiast.mp3",
    topics: ["Performance", "Acting", "Versatility"],
    featured: false
  },
  {
    id: 6,
    title: "Entrepreneurship in Entertainment",
    description: "Insights from co-founding Fiery Ize Vision and supporting emerging talent in the entertainment industry.",
    duration: "44:20",
    date: "2025-12-15",
    season: 1,
    episode: 7,
    audioUrl: "https://files.freemusicarchive.org/storage-freemusicarchive-org/music/no_curator/Tours/Enthusiast/Tours_-_01_-_Enthusiast.mp3",
    topics: ["Business", "Entrepreneurship", "Talent Development"],
    featured: false
  },
  {
    id: 7,
    title: "Giving Back: Philanthropy and Community",
    description: "The importance of charitable work, youth development, and arts education in building stronger communities.",
    duration: "39:55",
    date: "2025-12-01",
    season: 1,
    episode: 6,
    audioUrl: "https://files.freemusicarchive.org/storage-freemusicarchive-org/music/no_curator/Tours/Enthusiast/Tours_-_01_-_Enthusiast.mp3",
    topics: ["Philanthropy", "Community", "Youth"],
    featured: false
  },
  {
    id: 8,
    title: "Behind the Hits: Summertime and More",
    description: "A deep dive into the creation process behind fan-favorite tracks including Summertime, Push It On Me, and Independence.",
    duration: "47:12",
    date: "2025-11-15",
    season: 1,
    episode: 5,
    audioUrl: "https://files.freemusicarchive.org/storage-freemusicarchive-org/music/no_curator/Tours/Enthusiast/Tours_-_01_-_Enthusiast.mp3",
    topics: ["Music Production", "Creative Process", "Songwriting"],
    featured: false
  }
];

export const platformLinks = [
  { name: "Spotify", url: "#", icon: "Music" },
  { name: "Apple Podcasts", url: "#", icon: "Podcast" },
  { name: "YouTube", url: "#", icon: "Youtube" },
  { name: "Google Podcasts", url: "#", icon: "Radio" },
  { name: "RSS Feed", url: "#", icon: "Rss" }
];
